import type { Palette } from './palette.type';

export const palette: Palette = {
  primary: {
    main: '#094639',
    light: '#4E7A70',
    dark: '#002924',
    bg: '#F7F9F2',
  },
  secondary: {
    main: '#FF6635',
    light: '#FF9370',
    dark: '#CC5833',
    bg: '#FFF4F0',
  },
  error: {
    main: '#D22E19',
    light: '#EE7C6D',
    dark: '#B62816',
    bg: '#FFF1F0',
  },
  warning: {
    main: '#C44A08',
    light: '#EA9161',
    dark: '#933706',
    bg: '#FFF5F0',
  },
  amber: {
    main: '#8F6B00',
    light: '#FFEBC6',
    dark: '#6B5100',
    bg: '#FFF9EE',
  },
  success: {
    main: '#308212',
    light: '#6BC44B',
    dark: '#1F550C',
    bg: '#EFFAEB',
  },
  neutral: {
    100: '#000000',
    90: '#595959',
    80: '#737373',
    70: '#A6A6A6',
    60: '#E6E6E6',
    50: '#F3F3F3',
    40: '#F8F8F8',
    10: '#FCFCFC',
    '00': '#FFFFFF',
  },
  focus: '#2C60F5',
  offWhite: '#F7F9F2',
  white: (alpha: number) => `rgba(255, 255, 255, ${alpha})`,
  black: (alpha: number) => `rgba(0, 0, 0, ${alpha})`,
};
